/**
 * Client Component: clear in-memory API token when the user signs out,
 * and force logout after 8 hours with no authenticated API calls.
 */

'use client'

import { useBackendToken } from '@/hooks/useBackendToken'
import { useSessionIdleLogout } from '@/hooks/useSessionIdleLogout'

const BackendTokenManager = () => {
  useBackendToken()
  useSessionIdleLogout()
  return null
}

export default BackendTokenManager
